import Utils from '../../../components.utils.js';

export default {
    getLoggedInUser(state) {
        return state.loggedInUser;
    },
    getLoggedInUserInfo(state) {
        if (!state.loggedInUserInfo) {
            return state.loggedInUserInfo;
        }
        return {
            ...state.loggedInUserInfo,
            profile_image: state.loggedInUserInfo.profile_image
                ? Utils.convertToLoginIPDomainName(state.loggedInUserInfo.profile_image)
                : state.loggedInUserInfo.profile_image
        };
        //return state.loggedInUserInfo;
    },
    getLoggedInUserId(state) {
        return state.loggedInUserId;
    },
    getLoggedInUserType(state){
        return state.loggedInUserInfo.user_type;
    },
    getIsMetadataDockVisible(state) {
        return state.isMetadataDockVisible;
    },
    getIsAssetsDetailsPanelVisible(state) {
        return state.isAssetsDetailsPanelVisible;
    },
    getSelectedPlayerPanel(state) {
        return state.selectedPlayerPanel;
    },
    getisMiniplayerVisible(state) {
        return state.isMiniplayerVisible;
    },
    getLoggedInUserAccessControl(state) {
        return state.loggedInUserInfo.access_control;
    },
    getLoggedInUserPrivilege(state){
        let privilleges = state.loggedInUserInfo.access_control.privileges;
        return privilleges;
    },
    getClientSystemIP(state){
        return state.ip
    },
    getUsersBasicInfoFromStore(state){
        return state.usersBasicInfo
    }
};